export default new class InputMask {
    constructor() {
        this.$timeMaskElems = $('.js-workingHoursInput');
        this.phone = '.js-phone';

        this.setTimeMask();
        this.setPhoneMask();
        this.setUnpMask();

    }
    setPhoneMask() {
        $.mask.definitions['h'] = '[0-9]';
        $(this.phone).mask('+hhh hh hhh-hh-hh');
    }

    setUnpMask() {
        $.mask.definitions['h'] = '[0-9]';
        $(this.phone).mask('hhh hhh hhh');
    }

    setTimeMask() {
        $.mask.definitions['H'] = '[0-2]';
        $.mask.definitions['h'] = '[0-9]';
        $.mask.definitions['M'] = '[0-5]';
        $.mask.definitions['m'] = '[0-9]';

        this.$timeMaskElems.mask('Hh:Mm');
    }
};




// WEBPACK FOOTER //
// ./src/common/assets/js/inputMask.js